const getters = {
  isExcursionTypesLoaded(state) {
    return state.types.length > 0;
  },
  isRiskCategoriesOptionsLoaded(state) {
    return Object.values(state.riskCategoriesOptions).length > 0;
  }
};

export default getters;
